export default __webpack_public_path__ + "static/media/196.eeefb9b2.jpg";